// src/i18n.js
import i18n, { setDefaultNamespace } from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend'; 
import LanguageDetector from 'i18next-browser-languagedetector';

 
i18n
  .use(Backend) 
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en', 
    debug: true, 
    interpolation: { escapeValue: false }, 
    resources: {
      en: {
        homepage: require('./locales/en/homepage.json'),
        invoicepage:require('./locales/en/invoicepage.json'),
        paymentpage:require('./locales/en/paymentpage.json'),
        commercialVehicleLoanPage:require('./locales/en/commercialVehicleLoanPage.json'),
        businessExpansionPage:require('./locales/en/businessExpansionPage.json'),
        businessListingLanding:require('./locales/en/businessListingLanding.json'),
        inventoryFinancingPage:require('./locales/en/inventoryFinancingPage.json'),
        bizzieChatPage:require('./locales/en/bizzieChat.json'),
        lenderPage:require('./locales/en/lenderPage.json'),
        footer:require('./locales/en/footer.json')
      },
      hi: {
        homepage: require('./locales/hi/homepage.json'),
        invoicepage:require('./locales/hi/invoicepage.json'),
        paymentpage:require('./locales/hi/paymentpage.json'),
        commercialVehicleLoanPage:require('./locales/hi/commercialVehicleLoanPage.json'),
        businessExpansionPage:require('./locales/hi/businessExpansionPage.json'),
        businessListingLanding:require('./locales/hi/businessListingLanding.json'),
        inventoryFinancingPage:require('./locales/hi/inventoryFinancingPage.json'),
        bizzieChatPage:require('./locales/hi/bizzieChat.json'),
        lenderPage:require('./locales/hi/lenderPage.json'),
        footer:require('./locales/hi/footer.json')
      },
      mr: {
        homepage: require('./locales/mr/homepage.json'),
        invoicepage:require('./locales/mr/invoicepage.json'),
        paymentpage:require('./locales/mr/paymentpage.json'),
        commercialVehicleLoanPage:require('./locales/mr/commercialVehicleLoanPage.json'),
        businessExpansionPage:require('./locales/mr/businessExpansionPage.json'),
        businessListingLanding:require('./locales/mr/businessListingLanding.json'),
        inventoryFinancingPage:require('./locales/mr/inventoryFinancingPage.json'),
        bizzieChatPage:require('./locales/mr/bizzieChat.json'),
        lenderPage:require('./locales/mr/lenderPage.json'),
        footer:require('./locales/mr/footer.json')
      },
      gu: {
        homepage: require('./locales/gu/homepage.json'),
        invoicepage:require('./locales/gu/invoicepage.json'),
        paymentpage:require('./locales/gu/paymentpage.json'),
        commercialVehicleLoanPage:require('./locales/gu/commercialVehicleLoanPage.json'),
        businessExpansionPage:require('./locales/gu/businessExpansionPage.json'),
        businessListingLanding:require('./locales/gu/businessListingLanding.json'),
        inventoryFinancingPage:require('./locales/gu/inventoryFinancingPage.json'),
        bizzieChatPage:require('./locales/gu/bizzieChat.json'),
        lenderPage:require('./locales/gu/lenderPage.json'),
        footer:require('./locales/gu/footer.json')
      }
    },
    ns: ['homepage','invoicepage','paymentpage','commercialVehicleLoanPage','businessExpansionPage','businessListingLanding','inventoryFinancingPage','bizzieChatPage','lenderPage'], 
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['cookie'], // Store the selected language in a cookie
    },
  });
  




export default i18n;